module.exports = __webpack_public_path__ + "static/img/_empty.8c531f17.png";